


























import {defineComponent} from "@vue/composition-api"
import FloatingPopup from "./FloatingPopup.vue"
import router from "@/router"

export default defineComponent({
  components: {FloatingPopup},
  setup() {
    const myAccountUrl = "#" // `${store.state.appList.accountsApplicationUrl}/user?id=${store.state.userInfo.userId}&app=MAC&returnTo=${encodeURIComponent(window.location.href)}`
    const logout = () => router.push({name: "logout"})
    return {logout, myAccountUrl}
  },
})
